import { h } from 'preact'
export const ArrowLeft = () => {
    return (
      <svg class="icon icon-recs-arrow-left" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Group 1538231535">
          <circle id="Ellipse 9817" cx="28" cy="28" r="27.5" transform="matrix(-1 0 0 1 56 0.543701)" stroke="black"/>
          <path id="Rectangle 280857" d="M32 40.5437L21.5246 30.0683C20.6826 29.2263 20.6826 27.8611 21.5246 27.0191L32 16.5437" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
      </svg>
    )
}